import React, { FunctionComponent } from 'react';

import { Box, Center, Flex, Heading } from '@chakra-ui/react';

import { CustomModal } from 'presentation/components/CustomModal';
import { ElementInfo } from 'presentation/components/ElementInfo';
import { IInfoModalProps } from './IInfoModalProps';

import { ReactComponent as FoodIcon } from "./food1-icon.svg";

export const InfoModal: FunctionComponent<IInfoModalProps> = (props) => {

    function _getLinks(links?: string): any {
        return links?.split(" ") ?? [];
    }

    return (
        <CustomModal
            title="Información de alimento"
            isOpen={props.isOpen}
            onClose={props.onClose}
        >
            { props.food &&
                <Box bg="#ffffff" p={{ base: "15px", md: "20px" }}>
                    <Flex marginBottom="10px">
                        <Box d="flex">
                            <FoodIcon width="35px" />
                        </Box>
                        <Box d="flex">
                            <Heading as="h4" size="md" textAlign="center">
                                {props.food.name}
                            </Heading>
                        </Box>
                    </Flex>
                    <ElementInfo
                        description={props.food.description}
                        sources={_getLinks(props.food.sources)}
                        showTechInformation={false}
                    />
                </Box>
            }
            {!props.food &&
                <Center>
                    Sin información disponible
                </Center>
            }
        </CustomModal>
    );
}